import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { HttpClientModule } from '@angular/common/http';
import { ButtonComponent } from './components/button/button.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { RadioComponent } from './components/radio/radio.component';
import { ToggleComponent } from './components/toggle/toggle.component';
import { RequestsComponent } from './components/requests/requests.component';
import { CompletenessComponent } from './components/completeness/completeness.component';
import { MultiStepProgressComponent } from './components/multistep-progress/multistep-progress.component';
import { ImageUploaderComponent } from './components/image-uploader/image-uploader.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { HamburgerComponent } from './components/hamburger/hamburger.component';
import { WeightBarComponent } from './components/weight-bar/weight-bar.component';
import { SliderComponent } from './components/slider/slider.component';
import { CopyClipboardComponent } from './components/copyclipboard/copyclipboard.component';
import { UserAvatarComponent } from './components/user-avatar/user-avatar.component';
import { InstallPromptComponent } from './components/install-prompt/install-prompt.component';
import { FileUploaderComponent } from './components/file-uploader/file-uploader.component';
import { MapsComponent } from './components/maps/maps.component';
import { SearchComponent } from './components/search/search.component';
import { OrderByComponent } from './components/orderby/orderby.component';
import { UserCardComponent } from './components/user-card/user-card.component';
import { AccordionComponent } from './components/accordion/accordion.component';
import { VerifiedBadgeComponent } from './components/verified-badge/verified-badge.component';
import { BadgeComponent } from './components/badge/badge.component';
import { LogoComponent } from './components/logo/logo.component';
import { InputComponent } from './components/input/input.component';
import { FlagComponent } from './components/flag/flag.component';
import { OverviewCardComponent } from './components/overview-card/overview-card.component';
import { CountryDropdownComponent } from './components/country-dropdown/country-dropdown.component';
import { SelectlistComponent } from './components/select-list/select-list.component';
import { IconComponent } from './components/icon/icon.component';
import { TokenComponent } from './components/token/token.component';
import { LocationSelectorComponent } from './components/location-selector/location-selector.component';
import { ProgressComponent } from './components/progress/progress.component';
import { FileInputComponent } from './components/file-input/file-input.component';
import { UploadBoxComponent } from './components/upload-box/upload-box.component';
import { UploadBox2Component } from './components/upload-box2/upload-box2.component';
import { PhotoPreviewComponent } from './components/photo-preview/photo-preview.component';
import { InputListGroupComponent } from './components/input-list-group/input-list-group.component';
import { LoaderComponent } from './components/loader/loader.component';
import { SelectOptionComponent } from './components/select-option/select-option.component';
import { AuthHeaderComponent } from './components/auth-header/auth-header.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { SideMenuComponent } from './components/side-menu/side-menu.component';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { InputDebitCardComponent } from './components/input-debit-card/input-debit-card.component';
import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { SearchBarV2Component } from './components/search-bar-v2/search-bar-v2.component';
import { ListingSideFilterComponent } from './components/listing-side-filter/listing-side-filter.component';
import { PropertyWizardComponent } from './components/property-wizard/property-wizard.component';
import { BackButtonComponent } from './components/back-button/back-button.component';
export { RangeFilterComponent } from './components/range-filter/range-filter.component';


import { CurrencyInputDirective } from './directives/currency-input/currency-input.directive';
import { FocusFormDirective } from './directives/focus-form/focus-form.directive';
import { TogglePasswordVisibilityDirective } from './directives/toggle-password-visibility/toggle-password-visibility.directive';
import { InputOTPDirective } from './directives/input-otp/input-otp.directive';

import { FullNamePipe } from './pipes/full-name/full-name-pipe';
import { TimeSincePipe } from './pipes/time-since/time-since-pipe';
import { AddressPipe } from './pipes/address/address.pipe';
import { FirstNamePipe } from './pipes/first-name/first-name-pipe';
import { NumPipe } from './pipes/num/num.pipe';
import { ReversePipe } from './pipes/reverse/reverse.pipe';
import { CountPipe } from './pipes/count/count.pipe';
import { PropertyNamePipe } from './pipes/property/property-name.pipe';
import { PropertyAddressPipe } from './pipes/property/address.pipe';
import { TelephoneNumberPipe } from './pipes/tel/tel.pipe';
import { OccupancyTypePipe } from './pipes/property/occupancy-type.pipe';
import { PropertyTypeAsyncPipe } from './pipes/property/property-type.pipe-async';
import { CoverImagePipe } from './pipes/property/cover-image.pipe';
import { PropertyDisplayNamePipe } from './pipes/property/display-name.pipe';
import { PropertyDescriptionPipe } from './pipes/property/description.pipe';
import { RentCyclePipe } from './pipes/property/rent-cycle.pipe';
import { InitialsPipe } from './pipes/initials/initials-pipe';
import { CharPipe } from './pipes/char/char-pipe';
import { IsUserPipe } from './pipes/is-user/is-user.pipe';
import { PostCodePipe } from './pipes/postcode/postcode.pipe';
import { CmsImagePrefixPipe } from './pipes/cms-images/cms-image-prefix.pipe';
import { FlyOverDurationPipe } from './pipes/fly-over-duration/fly-over-duration.pipe';

import { PropertyWizardService } from './singletons/property-wizard-service';
import { ListingPublishService } from './singletons/listing-publish-service';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { FeatureDirective } from './directives/feature-directive/feature.directive';
import { CustomRadioComponent, PropertySearchListingComponent, PropertySearchMapComponent, PropertySearchPopupComponent, RangeFilterComponent } from './components';
import { TruncateEmailPipe } from './pipes/truncate/truncate-email.pipe';
import { BookingWizardService } from './singletons/booking-wizard.service';
import { CorporateAccountWizardService } from './singletons/corporate-account-wizard-service';
import { RightHandSideWizardComponent } from './components/right-hand-side-wizard/right-hand-side-wizard.component';
import { OccupantsPipe } from './pipes/occupants/occupants.pipe';
import { BookingTotalPipe } from './pipes/booking-total/booking-total.pipe';
import { TimeFormatMeridiemPipe } from './pipes/time-format/time-format-meridiem.pipe';
import { PropertiesFilterComponent } from './components/property-filter/properties-filter.component';
import { AmenitiesModalComponent } from './components/amenities-modal/amenities-modal.component';
import { ListingThumbnailPipe } from './pipes/listing-thumbnail/listing-thumbnail.pipe';
import { InfiniteScrollComponent } from './components/infinite-scroll/infinite-scroll.component';
import { HotelRoomListsComponent } from './components/hotel-room-lists/hotel-room-lists.component';
import { BookingRestrictionModalComponent } from './components/booking-restriction-modal/booking-restriction-modal.component';
import { PaginationV2Component } from './components/pagination-v2/pagination-v2.component';


const modules = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  HttpClientModule,
  RouterModule,
  FontAwesomeModule,

]

const components = [
  IconComponent,
  LogoComponent,
  ButtonComponent,
  CheckboxComponent,
  RadioComponent,
  ToggleComponent,
  RequestsComponent,
  CompletenessComponent,
  MultiStepProgressComponent,
  ImageUploaderComponent,
  PaginationComponent,
  HamburgerComponent,
  WeightBarComponent,
  SliderComponent,
  CopyClipboardComponent,
  UserAvatarComponent,
  InstallPromptComponent,
  FileUploaderComponent,
  MapsComponent,
  SearchComponent,
  SearchBarComponent,
  SearchBarV2Component,
  OrderByComponent,
  UserCardComponent,
  AccordionComponent,
  VerifiedBadgeComponent,
  BadgeComponent,
  LogoComponent,
  InputComponent,
  FlagComponent,
  OverviewCardComponent,
  CountryDropdownComponent,
  SelectlistComponent,
  TokenComponent,
  LocationSelectorComponent,
  ProgressComponent,
  FileInputComponent,
  UploadBoxComponent,
  UploadBox2Component,
  PhotoPreviewComponent,
  InputListGroupComponent,
  LoaderComponent,
  SelectOptionComponent,
  AuthHeaderComponent,
  FooterComponent,
  HeaderComponent,
  SideMenuComponent,
  ConfirmModalComponent,
  InputDebitCardComponent,
  PropertyWizardComponent,
  BackButtonComponent,
  PropertySearchListingComponent,
  PropertySearchPopupComponent,
  PropertySearchMapComponent,
  RightHandSideWizardComponent,
  CustomRadioComponent,
  PropertiesFilterComponent,
  AmenitiesModalComponent,
  InfiniteScrollComponent,
  HotelRoomListsComponent,
  BookingRestrictionModalComponent,
  PaginationV2Component,
  RangeFilterComponent,
  ListingSideFilterComponent
]

const directives = [
  CurrencyInputDirective,
  FocusFormDirective,
  TogglePasswordVisibilityDirective,
  InputOTPDirective,
  FeatureDirective
]

const pipes = [
  AddressPipe,
  FirstNamePipe,
  FullNamePipe,
  NumPipe,
  ReversePipe,
  TimeSincePipe,
  TelephoneNumberPipe,
  CountPipe,
  PropertyAddressPipe,
  PropertyDisplayNamePipe,
  PropertyNamePipe,
  OccupancyTypePipe,
  PropertyTypeAsyncPipe,
  PropertyDescriptionPipe,
  CoverImagePipe,
  InitialsPipe,
  CharPipe,
  IsUserPipe,
  PostCodePipe,
  RentCyclePipe,
  TruncateEmailPipe,
  OccupantsPipe,
  BookingTotalPipe,
  TimeFormatMeridiemPipe,
  CmsImagePrefixPipe,
  ListingThumbnailPipe,
  FlyOverDurationPipe,
]

const services = [
  PropertyWizardService,
  ListingPublishService,
  BookingWizardService,
  CorporateAccountWizardService
]

@NgModule({
  imports: [
    ...modules,
    BsDatepickerModule.forRoot(),
  ],
  declarations: [
    ...components,
    ...directives,
    ...pipes,
  ],
  exports: [
    ...modules,
    ...components,
    ...directives,
    ...pipes,
  ],
  providers: [
    ...pipes,
    ...services,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA,
  ],
})
export class ClooperCommonModule { }
